import axios from "axios";
import queryString from "query-string";
// import loadConfig, { getApiClient, initializeApiClient } from "../apiService";

import { CookiesProvider, useCookies } from "react-cookie";
import Cookies from "js-cookie";
import loadConfig, { getApiClient, initializeApiClient } from "../Api/ApiServices";
const LogOutServices = async () => {
  let jsonData = await loadConfig();

  await initializeApiClient();
  // // الآن يمكنك استخدام apiClient بعد التهيئة
  const apiClient = await getApiClient();
  const response = await apiClient.post("/api/Account/RevokeToken", {
    token: Cookies.get("Refreshtoken"),
  });
  const writeCookie = (cname, cvalue, days) => {
    var dt, expires;
    dt = new Date();
    dt.setTime(dt.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + dt.toGMTString();
    document.cookie =
      cname +
      "=" +
      cvalue +
      expires +
      `; path=/; domain=${jsonData.coookiesDomain}`;
  };
  const deleteAllCookies = () => {
    const cookies = document.cookie.split(";");
    ////////console.log("cookies",cookies);
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      writeCookie(name, " ", -5000);
    }
    window.location.reload(true);
  };
  if (window.location.href.includes("manager")) {
    Cookies.remove("AccessTokenManager");
    Cookies.remove("RefreshtokenManager");
    sessionStorage.removeItem("AccessTokenManager");
    sessionStorage.removeItem("RefreshtokenManager");
    localStorage.clear();
    deleteAllCookies();
    window.location.replace(jsonData.internalSsoUrlreturn);
  } else {
    Cookies.remove("AccessToken");
    Cookies.remove("Refreshtoken");
    sessionStorage.removeItem("AccessToken");
    sessionStorage.removeItem("Refreshtoken");
    localStorage.clear();
    window.location.replace("https://login.shoman.org/?Page=Logout");
  }
};

export default LogOutServices;
